import React, { useState, useEffect } from 'react';
import Axios from '../../axios/axios';
import { Link, useNavigate } from 'react-router-dom';

export default function PendingCustomers() {
  const [products, setProducts] = useState([]);
  const [searchKey, setSearchKey] = useState('');

  useEffect(() => {
    getProducts();
  }, [searchKey]);

  const getProducts = async () => {
    let obj = { phone: searchKey };
    await Axios.post(`/api/user/list/pending`, obj).then((res) => {
      setProducts(res?.data?.users);
    });
  };

  const search = (value) => {
    setSearchKey(value);
  };

  console.log(products);
  return (
    <div class="row">
      <div class="col-lg-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <div class="d-flex">
              <div class="mr-auto p-2">
                {' '}
                <h4 class="card-title">Customer List </h4>
              </div>
              <div class="  p-2">
                <input
                  type="number"
                  className="form-control"
                  placeholder="Search Number here..."
                  onKeyDown={(e) => search(e.target.value)}
                />
              </div>
            </div>

            <div class="table-responsive">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Customer Name</th>
                    <th>Place</th>
                    <th> Phone</th>
                    <th> Balance</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {products?.length > 0 ? (
                    products?.map((user, index) => (
                      <tr>
                        <td>{index + 1}</td>
                        <td>
                          <Link to={`/user/${user?._id}`}>{user?.name}</Link>
                        </td>
                        <td>{user?.address1.slice(0, 15)}</td>
                        <td>
                          {user?.phone} /{user?.phone1}
                        </td>
                        <td>
                          <div
                            class={
                              user?.balanceAmount > 5000
                                ? `badge badge-danger pl-3 pr-3`
                                : `badge badge-warning pl-3 pr-3`
                            }
                          >
                            {' '}
                            {user?.balanceAmount}
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={6}>
                        Customer not found on this mobile number
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
